import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import Button from "../../../Parts/Button";
import DialogModal from "../../../common/DialogModal";

const styles = () => ({
  text: {
    margin: "25px 0px 40px 0px",
    textAlign: "left",
  },

  button: {
    background: "#F03A47",
    "&:hover::before": {
      backgroundColor: "#F03A47",
      opacity: 0.6,
    },
  },

  contentContainer: {
    padding: "50px 40px",
    margin: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    width: "600px",
    boxSizing: "border-box",
    background: "#FFFFFF",
  },

  buttonContainer: {
    display: "inline-flex",
    width: "100%",
    justifyContent: "center",
  },

  row: {
    display: "block",
    marginBottom: "4px",
  },
});

class ConfirmRevokeDialog extends React.Component {
  handleClick = () => {
    this.props.action();
    this.props.toggleDialog();
  };

  render() {
    const { classes, isOpen, toggleDialog, buttonText } = this.props;

    return (
      <DialogModal
        open={isOpen}
        onClose={toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          contentContainer: classes.contentContainer,
        }}
      >
        <Typography variant="title" style={{ fontWeight: "bold" }}>
          連携を解除する
        </Typography>
        <Typography variant="subheading" className={classes.text}>
          <span className={classes.row}>
            Salesforceとの連携を解除します。連携を解除した場合、Salesforceアカウントからインポートしたアドレス並びにSalesforceアカウントにエクスポートされたキーマンレターのキャンペーンと取引先データ、リードデータも削除されます。
            この処理は数分かかります。よろしいですか？
          </span>
        </Typography>
        <div className={classes.buttonContainer}>
          <Button
            color="red"
            handleClickButton={this.handleClick}
            text={buttonText}
            loading={this.props.isLoading}
            style={{
              backgroundColor: "#FF606C",
            }}
          ></Button>
        </div>
      </DialogModal>
    );
  }
}

ConfirmRevokeDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  action: PropTypes.func.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  buttonText: PropTypes.string,
};

export default withStyles(styles)(ConfirmRevokeDialog);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/dialogs/ConfirmRevokeDialog.jsx